var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForumchannels(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0446 16H21.2174V7.96226C21.2174 4.11321 18.0674 1 14.1728 1H8.0446C4.15004 1 1.00002 4.11321 1.00002 7.96226V9.09434C1.05729 12.8868 4.20731 16 8.0446 16Z",
    stroke: "#747474",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3479 10.0001C14.6275 10.0001 14.0435 9.41608 14.0435 8.69571C14.0435 7.97533 14.6275 7.39136 15.3479 7.39136C16.0682 7.39136 16.6522 7.97533 16.6522 8.69571C16.6522 9.41608 16.0682 10.0001 15.3479 10.0001Z",
    fill: "#747474"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4347 10.0001C10.7143 10.0001 10.1303 9.41608 10.1303 8.69571C10.1303 7.97533 10.7143 7.39136 11.4347 7.39136C12.155 7.39136 12.739 7.97533 12.739 8.69571C12.739 9.41608 12.155 10.0001 11.4347 10.0001Z",
    fill: "#747474"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52158 10.0001C6.80121 10.0001 6.21723 9.41608 6.21723 8.69571C6.21723 7.97533 6.80121 7.39136 7.52158 7.39136C8.24195 7.39136 8.82593 7.97533 8.82593 8.69571C8.82593 9.41608 8.24195 10.0001 7.52158 10.0001Z",
    fill: "#747474"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForumchannels);
export default __webpack_public_path__ + "static/media/Forum channels.c40ccb80e6dea3fa0bd0950dc2bf1802.svg";
export { ForwardRef as ReactComponent };